import queryString from 'query-string';
import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"react-router"' has no exported member 'Lo... Remove this comment to see the full error message
import { Location, RouterHistory, withRouter } from 'react-router';
import { sprintf } from 'sprintf-js';

import { logIn } from 'api/currentUser';
import LoginForm from 'components/LoginForm';
import { saveListing, updateCurrentUser } from 'store/main/ducks/currentUser';
import { pushFlashMessage } from 'store/main/ducks/flashMessages';
import { showModal } from 'store/main/ducks/modal';
import { subscribeToSubsite } from 'store/main/ducks/subscribedSubsites';
import { trackLogin } from 'utils/analytics';
import configureTrackJs from 'utils/configureTrackJs';
import { LOGIN_PROVIDER_NAMES } from 'utils/constants/general';
import { createCookie, deleteCookie } from 'utils/cookies';
import getThirdPartyLoginUrl from 'utils/getThirdPartyLoginUrl';

type OwnProps = {
  isModal: boolean;
  redirectTo: string | null | undefined;
  email?: string | null | undefined;
  savedListing?:
    | {
        id: string;
        type: string;
        name: string;
      }
    | null
    | undefined;
  subscribedSubsite?: string | null | undefined;
  inviteId?: string | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onLogin: ((...args: Array<any>) => any) | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  signUpOverrideFn?: (...args: Array<any>) => any;
  header?: ReactNode;
  centered?: boolean;
  initialWarning?: string | null | undefined;
  compactView?: boolean;
};
type Props = OwnProps & {
  location: Location;
  history: RouterHistory;
  updateCurrentUser: typeof updateCurrentUser;
  pushFlashMessage: typeof pushFlashMessage;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  saveListing: (arg0: string, arg1: string, arg2: string) => Promise<any>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subscribeToSubsite: (arg0: string) => Promise<any>;
  showModal: typeof showModal;
};
type State = {
  thirdPartyLoginError: string | null | undefined;
  initialWarning: string | null | undefined;
};

class LoginFormContainer extends React.Component<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    thirdPartyLoginError: null,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    initialWarning: this.props.initialWarning,
  };

  isMounted = false;

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/sort-comp
  get initialValues() {
    const { props } = this;
    return {
      email: props.email || '',
      password: '',
    };
  }

  componentDidMount() {
    this.isMounted = true;
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  static getDerivedStateFromProps(nextProps) {
    const { error, provider } = queryString.parse(nextProps.location.search);
    if (!error) return null;
    // @ts-expect-error ts-migrate(2538) FIXME: Type 'string[]' cannot be used as an index type.
    const providerName = LOGIN_PROVIDER_NAMES[provider];
    let errorMessage;

    if (error === 'EXISTING_ACCOUNT' && providerName) {
      // TRANSLATORS: error message when user tries to log in using
      // TRANSLATORS: Facebook or Google but they already had an account
      // TRANSLATORS: that did not use that login provider
      errorMessage = sprintf(
        getText(
          'Please log in first to associate that %(provider)s ' +
            'account to your existing Idealist account'
        ),
        {
          provider: providerName,
        }
      );
    }

    if (error === 'MISMATCHED_ACCOUNTS' && providerName) {
      // TRANSLATORS: User tried to link Facebook/Google account, but
      // TRANSLATORS: it was already used by another Idealist acccount
      errorMessage = sprintf(
        getText(
          'That %(provider)s account is already associated with ' +
            'another Idealist account'
        ),
        {
          provider: providerName,
        }
      );
    }

    if (error === 'FAILED_OAUTH_LOGIN') {
      // TRANSLATORS: user used 3rd party authentication like Google, but it failed
      errorMessage = getText(
        'Authentication did not work as expected, please try again.'
      );
    }

    if (error === 'USER_FROZEN') {
      // TRANSLATORS: user tried to login, but user is frozen
      errorMessage = getText(
        'Your account has been frozen for violating our Terms of Service.'
      );
    }

    if (errorMessage) {
      // remove error and provider params from URL
      const params = queryString.parse(nextProps.location.search);
      delete params.error;
      delete params.provider;
      nextProps.history.replace({
        pathname: nextProps.location.pathname,
        search: queryString.stringify(params),
      });
      return {
        thirdPartyLoginError: errorMessage,
      };
    }

    return null;
  }

  showSignupModal = (email: string) => {
    const { props } = this;
    props.showModal('SIGNUP', {
      redirectTo: props.redirectTo,
      savedListing: props.savedListing,
      subscribedSubsite: props.subscribedSubsite,
      email,
    });
  };

  getSignupUrl = (email: string) => {
    const { redirectTo, inviteId, savedListing, subscribedSubsite } =
      this.props;
    return {
      pathname: '/signup',
      state: {
        redirectTo,
        email,
        inviteId,
        savedListing,
        subscribedSubsite,
      },
    };
  };

  showForgotPasswordModal = (state: {
    email: string;
    showUnsupportedServiceMessage?: boolean;
  }) => {
    const { props } = this;
    props.showModal('FORGOT_PASSWORD', state);
  };

  // eslint-disable-next-line class-methods-use-this
  getForgotPasswordUrl = (state: {
    email: string;
    showUnsupportedServiceMessage?: boolean;
  }) => ({
    pathname: '/forgot-password',
    state,
  });

  getThirdPartyLoginUrl = (provider: 'facebook' | 'google') => {
    const { redirectTo, inviteId, savedListing, subscribedSubsite } =
      this.props;
    return getThirdPartyLoginUrl({
      provider,
      redirectTo,
      inviteId,
      savedListing,
      subscribedSubsite,
    });
  };

  submitLogin = ({
    values,
    handleError,
  }: {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    values: Record<string, any>;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleError: (...args: Array<any>) => any;
  }) => {
    const { props } = this;
    deleteCookie('userDismissedNotificationPreferencesDialog');
    this.setState({
      initialWarning: null,
    });
    const loginInfo = {};
    Object.assign(loginInfo, values);

    if (props.subscribedSubsite) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'subscribeSubsiteId' does not exist on ty... Remove this comment to see the full error message
      loginInfo.subscribeSubsiteId = props.subscribedSubsite;
    }

    let user = null;
    logIn(loginInfo) // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line consistent-return
      .then((userArg) => {
        user = userArg;

        if (user.id) {
          trackLogin(user, 'Email Password');
          configureTrackJs(user.id);
        }

        if (user.locale) {
          createCookie('_LOCALE_', user.locale, 1825);
        }

        if (props.redirectTo && props.redirectTo.includes('tmpId')) {
          props.history.replace(props.redirectTo);
        }

        props.updateCurrentUser(user);

        if (props.savedListing) {
          const { type, name, id } = props.savedListing;
          return props.saveListing(id, type, name).then(() => {
            if (type === 'ORG') {
              props.pushFlashMessage({
                type: 'SAVE_ORG',
                data: {
                  orgName: name,
                },
              });
            } else if (type === 'GROUP') {
              props.pushFlashMessage({
                type: 'SAVE_GROUP',
                data: {
                  groupName: name,
                },
              });
            }
          });
        }
      }) // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line consistent-return
      .then(() => {
        if (props.subscribedSubsite) {
          return props.subscribeToSubsite(props.subscribedSubsite);
        }
      })
      .then(() => {
        if (props.subscribedSubsite) {
          props.pushFlashMessage({
            type: 'SUBSCRIBED_SUBSITE',
          });
        }

        if (props.onLogin) {
          props.onLogin(user);
        }
      })
      .catch(handleError)
      .finally(() => {
        if (this.isMounted) {
          this.setState({
            thirdPartyLoginError: null,
          });
        }
      });
  };

  render() {
    const { props, state } = this;
    return (
      <LoginForm
        initialValues={this.initialValues}
        thirdPartyLoginError={state.thirdPartyLoginError}
        isModal={props.isModal}
        showSignupModal={this.showSignupModal}
        getSignupUrl={this.getSignupUrl}
        signUpOverrideFn={props.signUpOverrideFn}
        showForgotPasswordModal={this.showForgotPasswordModal}
        getForgotPasswordUrl={this.getForgotPasswordUrl}
        getThirdPartyLoginUrl={this.getThirdPartyLoginUrl}
        submitLogin={this.submitLogin}
        header={props.header}
        centered={props.centered}
        initialWarning={state.initialWarning}
        compactView={props.compactView}
      />
    );
  }
}

// @ts-expect-error ts-migrate(2558) FIXME: Expected 2 type arguments, but got 1.
// eslint-disable-next-line import/no-default-export
export default withRouter<OwnProps>(
  connect(null, {
    updateCurrentUser,
    pushFlashMessage,
    showModal,
    saveListing,
    subscribeToSubsite,
  })(LoginFormContainer)
);
